import {Component, Inject} from '@angular/core';
import {
  ConfirmIconButtonComponent,
  DateElementComponent,
  DialogHeaderComponent,
  IDateFormElement,
  IFileUploadFormElement,
  ISelectFormElement,
  SelectElementComponent,
  UploadWrapperComponent,
} from "frontier/browserkit";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {INewPermanentOrdinanceForm} from "./new-permanent-ordinance-form.interface";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {INewPermanentOrdinanceDialog} from "./new-permanent-ordinance-dialog.interface";
import {PdfPipe} from '../../../../../../../../projects/frontier/browserkit/src/lib/pipes/pdf.pipe';

@Component({
  selector: 'app-new-permanent-ordinance-dialog',
  templateUrl: './new-permanent-ordinance-dialog.component.html',
  styleUrl: './new-permanent-ordinance-dialog.component.scss',
  standalone: true,
  imports: [DialogHeaderComponent, MatDialogContent, FormsModule, ReactiveFormsModule, SelectElementComponent,
    UploadWrapperComponent, DateElementComponent, MatDialogActions, ConfirmIconButtonComponent, PdfPipe]
})
export class NewPermanentOrdinanceDialogComponent {
  form: FormGroup<INewPermanentOrdinanceForm> = this.fb.group({
    itemGroup: this.fb.control(null, [Validators.required]),
    fromDate: this.fb.control(null, [Validators.required]),
    toDate: this.fb.control(null, [Validators.required]),
    document: this.fb.control(null, [Validators.required]),
  });
  itemGroup: ISelectFormElement = {
    label: 'Tarif',
    options: [],
    createNewEnabled: false,
    deleteElementEnabled: false,
    editElementEnabled: false,
    emptyOptionAdded: false,
  };
  fromDateData: IDateFormElement = {
    label: 'von',
    insertDelimiter: false,
  };
  toDateData: IDateFormElement = {
    label: 'bis',
    insertDelimiter: false,
  };
  documentData: IFileUploadFormElement = {
    readAs: 'ArrayBuffer',
    maxSize: 1024,
    selectType: 'upload',
    fileTypes: '.pdf',
  }

  protected readonly document = document;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: INewPermanentOrdinanceDialog,
    public dialogRef: MatDialogRef<NewPermanentOrdinanceDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.itemGroup.options = data.itemGroups || this.itemGroup.options;
  }
}
